import { DailyProgramCta } from '@go-shared/types/dailyProgram';
import { BubbleButton, BubbleFormGroup, BubbleInput } from '@go-client/components/BubbleUI';
import React from 'react';

interface CallToActionsProps {
  readOnly?: boolean;
  callToActions: DailyProgramCta[];
  onUpdate: (callToActions: DailyProgramCta[]) => void;
}

export const CallToActions: React.FC<CallToActionsProps> = ({
  readOnly,
  callToActions,
  onUpdate,
}: CallToActionsProps) => {
  return (
    <>
      {!readOnly && (
        <div className="text-xs text-slate italic mb-3">
          Make sure links start with http:// or https:// if you want them to open a webpage. You can
          also create links for email or phone numbers: mailto:johndoe@example.com → opens the
          guest's email to write to johndoe@example.com. tel:123-456-7890 → opens the phone app to
          call 123-456-7890.
        </div>
      )}
      <fieldset disabled={readOnly} className="grid grid-cols-1 gap-4 justify-items-start">
        {(callToActions || []).map((cta, i) => (
          <div key={i} className="w-full grid grid-cols-2 gap-4">
            <BubbleFormGroup label="Link" className="flex-grow">
              <BubbleInput
                type="text"
                block
                value={cta.link}
                onValue={val => {
                  const newCta = [...callToActions];
                  newCta[i].link = val;
                  onUpdate(newCta);
                }}
              />
            </BubbleFormGroup>
            <div className="flex-grow flex items-center">
              <BubbleFormGroup label="Label" className="flex-grow mr-3">
                <BubbleInput
                  type="text"
                  block
                  value={cta.label}
                  onValue={val => {
                    const newCta = [...callToActions];
                    newCta[i].label = val;
                    onUpdate(newCta);
                  }}
                />
              </BubbleFormGroup>
              <BubbleFormGroup label="New Tab">
                <BubbleInput
                  type="checkbox"
                  checked={cta.target === '_blank'}
                  onValue={chk => {
                    const newCta = [...callToActions];
                    newCta[i].target = chk ? '_blank' : '';
                    onUpdate(newCta);
                  }}
                />
              </BubbleFormGroup>

              {!readOnly && (
                <BubbleButton
                  style={{ alignSelf: 'end' }}
                  variant="crimson"
                  inverse
                  icon="trash-alt"
                  onClick={() => {
                    const newVal = [...callToActions];
                    newVal.splice(i, 1);
                    onUpdate(newVal);
                  }}
                />
              )}
            </div>
          </div>
        ))}
        {readOnly && !callToActions.length && <span className="text-smoke italic">None</span>}
        {!readOnly && (
          <>
            <BubbleButton
              variant="slate"
              onClick={() =>
                onUpdate([...callToActions, { link: '', label: '', target: '_blank' }])
              }
              icon="plus"
            >
              Add Call to Action
            </BubbleButton>
          </>
        )}
      </fieldset>
    </>
  );
};
